<template>
  <div class="lbv-device-list animated fadeIn roundedCard">
    <div class="row">
      <div class="col-lg-12">
        <b-card>
          <h1 class="lbv-page-title">
            Device List
          </h1>
          <div class="row secondary device-list-filters">
            <b-col
              md="3"
            >
              <b-form-group
                label="Order by"
                :label-cols="4"
              >
                <b-form-select
                  v-model="sortOption"
                  :options="sortOptions"
                  value=""
                  @input="fetchUserData"
                />
              </b-form-group>
            </b-col>
            <b-col
              md="3"
            >
              <b-form-group
                label="Filter by"
                :label-cols="3"
              >
                <b-form-select
                  v-model="filterOption"
                  :options="filterOptions"
                  @input="fetchUserData"
                />
              </b-form-group>
            </b-col>
            <b-col
              md="3"
            >
              <b-form-group
                label="Rows per page"
                :label-cols="6"
              >
                <b-form-select
                  v-model="perPage"
                  :options="pageOptions"
                  @input="fetchUserData"
                />
              </b-form-group>
            </b-col>
          </div> <!--end row-->
          <b-table
            responsive
            striped
            hover
            :items="deviceList"
            :fields="fields"
          >
            <template
              slot="leakbotId"
              slot-scope="data"
            >
              <router-link
                :to="{ name: 'DeviceView', params: { deviceID: data.value }}"
                class="deviceLink"
              >
                {{ data.value }}
              </router-link>
            </template>
          </b-table>
          <b-button
            class="page prev"
            variant="primary"
            size="sm"
            :disabled="currentPage === 1"
            @click.prevent="page"
          >
            Prev
          </b-button>

          <b-button
            class="page next"
            variant="primary"
            size="sm"
            :disabled="!hasNextPage"
            @click.prevent="page"
          >
            Next
          </b-button>
          <div class="current-page">
            Page: {{ currentPage }}
          </div>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import deviceListMixin from '../mixins/deviceListMixin'

export default {
  name: 'DeviceList',
  mixins: [deviceListMixin]
}
</script>

<style scoped>
  .lbv-device-list .clearBtn {
    margin-top: 10px;
  }

  .lbv-device-list .device-list-filters {
    margin: 0px 0px;
    border-bottom: 1px solid #C7CFCA;
    background-color: rgba(242, 242, 242, 1);
  }
</style>
